import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const GoogleSSOLogin: NextPage = () => <SsoSelfJoinRedirect newProvider="google" />;

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default GoogleSSOLogin;
